export type ExpiryOption<TKey extends string = string> = {
  value: TKey;
  label: string;
};

type ExpiryOptionsProps<TKey extends string = string> = {
  options: ExpiryOption<TKey>[];
  value: TKey;
  onChange: (value: TKey) => void;
};

export default function ExpiryOptions<TKey extends string = string>({
  options,
  value,
  onChange,
}: ExpiryOptionsProps<TKey>) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
            value === option.value
              ? "bg-indigo-500 text-white shadow-lg"
              : "bg-gray-100 text-gray-600 hover:bg-gray-200"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
